import { PercentLabel } from '../components/PercentLabel';
import { ITableMatchItem } from '../models/Match';
import { ProbabilityAllMarkets, ProbabilityMarkets } from '../models/Probability';
import format from 'date-fns/format';
import round from 'lodash/round';
export const addPercentLabelToMatchItemFields = (data: ITableMatchItem[]) =>
  data.map((item) => ({
    ...item,
    league: `${item.country} - ${item.league}`,
    avg: <PercentLabel value={item.avg}>{item.avg}</PercentLabel>,
    home: (
      <PercentLabel value={item.home} helperText={item.homeLastCount}>
        {item.home}
      </PercentLabel>
    ),
    away: (
      <PercentLabel value={item.away} helperText={item.awayLastCount}>
        {item.away}
      </PercentLabel>
    ),
    mutual: (
      <PercentLabel value={item.mutual} helperText={item.mutualLastCount}>
        {item.mutual}
      </PercentLabel>
    ),
  }));
const createPredictionValue = (item: ProbabilityAllMarkets, type: ProbabilityMarkets) => {
  const value = item.predictionPerMarket?.[type]?.predictionPercent;
  return value ? round(value * 100, 1) : 0;
};
export const addPercentLabelToPredictionItemFields = (data: ProbabilityAllMarkets[]) =>
  data.map((item) => ({
    ...item,
    match: `${item.homeTeam} - ${item.awayTeam}`,
    fullDate: format(new Date(item.startDate), 'HH:mm, d.MM'),
    classic: (
      <PercentLabel withoutHelperText value={createPredictionValue(item, 'classic')}>
        {createPredictionValue(item, 'classic')}
      </PercentLabel>
    ),
    over_35: (
      <PercentLabel withoutHelperText value={createPredictionValue(item, 'over_35')}>
        {createPredictionValue(item, 'over_35')}
      </PercentLabel>
    ),
    over_25: (
      <PercentLabel withoutHelperText value={createPredictionValue(item, 'over_25')}>
        {createPredictionValue(item, 'over_25')}
      </PercentLabel>
    ),
    btts: (
      <PercentLabel withoutHelperText value={createPredictionValue(item, 'btts')}>
        {createPredictionValue(item, 'btts')}
      </PercentLabel>
    ),
    // home_over_05: (
    //   <PercentLabel value={item.predictionPerMarket?.home_over_05?.predictionPercent ?? 0}>
    //     {item.predictionPerMarket?.home_over_05?.predictionPercent ?? 0}
    //   </PercentLabel>
    // ),
    // home_over_15: (
    //   <PercentLabel value={item.predictionPerMarket?.home_over_15?.predictionPercent ?? 0}>
    //     {item.predictionPerMarket?.home_over_15?.predictionPercent ?? 0}
    //   </PercentLabel>
    // ),
    // away_over_05: (
    //   <PercentLabel value={item.predictionPerMarket?.away_over_05?.predictionPercent ?? 0}>
    //     {item.predictionPerMarket?.away_over_05?.predictionPercent ?? 0}
    //   </PercentLabel>
    // ),
    // away_over_15: (
    //   <PercentLabel value={item.predictionPerMarket?.away_over_15?.predictionPercent ?? 0}>
    //     {item.predictionPerMarket?.away_over_15?.predictionPercent ?? 0}
    //   </PercentLabel>
    // ),
  }));
